<template lang="html">

	<section class="popup-confirmacion row-center">

		<div class="popup" :style="style.backgroundWhite">
			
			<template v-if="!!documentosnecesarios">

				<h2>¡Atención!</h2>

				<p>Necesitamos que añadas los siguientes documentos para poder inscribirte a la oferta.
					<strong>{{filelist}}</strong>
				</p>

				<div class="contenedor-upload">

					<h3>{{documentosnecesarios[docpos].nombre}}
						<span>({{docpos+1}}/{{documentosnecesarios.length}})</span>
					</h3>

					<article class="contenedor-input nuevo-documento -portfolio">
						<label for="">URL del documento</label>
						<input name="url" type="text" v-model="url" v-validate="'url'"
							:placeholder="'Introduce la URL de tu '+documentosnecesarios[docpos].nombre">
						<popup-info :texto="'url_portfolio'" :side="'left'"></popup-info>
						<span class='error'>{{ errors.first('url') }}</span>
					</article>

					<dropzone @emit="setDoc" ref="dropzone"></dropzone>

					<button @click="nextDoc" class="btn -solid-primary" :loading="loading">{{button}}</button>
					<button @click="cerrarPopup" class="btn -skull-primary">Cancelar</button>

					<p class="error animated shake" v-if="showerror">Por favor, adjunta un archivo o url</p>

				</div>



			</template>
	

		</div>

	</section>

</template>

<script lang="js">

	import Vue from 'vue';
	import VeeValidate from 'vee-validate';
	Vue.use(VeeValidate);

	import { mapGetters, mapActions } from 'vuex';

	import popupInfo from '@/components/parts/popup-info';

	import dropzone from '@/components/parts/form/dropzone';

	export default {
		name: 'popup-confirmacion-preinscripcion',
		props: ['id','documentosPendientes'],
		mounted() {
			this.documentosnecesarios=this.documentosPendientes;
		},
		data() {
			return {
				loading: false,
				documentosnecesarios: '',
				docpos: 0,
				showerror: false,
				url: '',
				postgrado: false,
				actualDoc: {
					"id": null,
					"fecha": null,
					"tipo": null,
					"enlace": null,
					"nombre": null,
					"ficheroB64ParaAltas": null,
					"extension_adjunto": null,
					"idDocumentoNecesarioOfertaNoTipado": null
				},
				docs: []
			}
		},
		components: {
			'popup-info': popupInfo,
			'dropzone': dropzone
		},
		computed: {
			...mapGetters({
				style: 'getStyles',
				colors: 'basicColors',
				brand : 'getBrand'
			}),
			button() {
				return (this.docpos + 1 == this.documentosnecesarios.length) ? 'Inscribirme' : 'Siguiente';
			},
			filelist() {

				if (!!this.documentosnecesarios) {

					let last = this.documentosnecesarios[this.documentosnecesarios.length - 1].nombre;
					let others = new Array();

					this.documentosnecesarios.slice(0, this.documentosnecesarios.length - 1).forEach(e => { others.push(e.nombre) });

					if (this.documentosnecesarios.length > 1) {
						return others.join(', ') + ' y ' + last;
					} else {
						return last;
					}

				}
			}
		},
		methods: {
			...mapActions(['aceptarPreinscripcion','setError']),
			sendIncribirseOferta: function (docs) {

				this.loading = true;

				let data = {
					"urlOferta": this.id,
					"documentacion": this.docs
				}

				this.aceptarPreinscripcion(data)
					.then(result => {
						if (result) {
							this.$emit('toggleInscrito', true);
						}
						if (!!result && !!result.documentacionPendienteFirma && Object.entries(result.documentacionPendienteFirma).length > 0) {
							this.$emit('tieneDocumentacionFirmablePendiente', result.documentacionPendienteFirma);
						}

						this.cerrarPopup();
					})
					.catch(error => {
						this.loading = false;
						this.documentosnecesarios = error.datos.documentacionNecesaria;
					});
			},
			setDoc(value) {
				for (let i in value) {
					this.actualDoc[i] = value[i];
				}
			},
			nextDoc() {

				if (!!this.url || !!this.actualDoc.ficheroB64ParaAltas) {
					this.$validator.validateAll()
						.then(itsOk => {
							if (itsOk) {
								this.actualDoc.tipo = this.documentosnecesarios[this.docpos].idTipo;
								this.actualDoc.nombre = this.documentosnecesarios[this.docpos].nombre;
								this.actualDoc.idDocumentoNecesarioOfertaNoTipado = this.documentosnecesarios[this.docpos].idDocumentoNecesario;
								this.actualDoc.enlace = this.url;
								this.docs.push(this.actualDoc);

								if (this.docpos == this.documentosnecesarios.length - 1) {
									this.sendIncribirseOferta(this.docs);
								} else {
									this.reset();
									this.docpos++;
								}
							}

						});

				} else {
					this.showerror = true;
				}
			},
			reset() {
				this.actualDoc = {
					"id": null,
					"fecha": null,
					"tipo": null,
					"enlace": null,
					"nombre": null,
					"ficheroB64ParaAltas": null,
					"extension_adjunto": null,
					"idDocumentoNecesarioOfertaNoTipado": null
				};
				this.url = '';
				(!!this.$refs.dropzone) ? this.$refs.dropzone.reset() : null;
			},
			cerrarPopup() {
				this.docpos = 0;
				this.documentosnecesarios = '';
				this.reset();
				this.$emit('cerrarPopup');
			}

		}
	}

</script>

<style scoped lang="scss">
	.popup-confirmacion {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 13;
		background: rgba(0, 0, 0, .5);
		padding: 10px;
	}

	.popup {
		width: 100%;
		max-width: 500px;
		padding: 25px;
		display: inline-block;

		p {
			a {
				text-decoration: underline;
				font-weight: 600;
			}
		}
	}

	.botones {
		margin-top: 20px;
		width: 100%;
	}

	h2 {
		text-align: left;
		margin-bottom: 20px;
		font-weight: 800;
	}

	.contenedor-upload {
		margin-top: 10px;

		h3 {
			text-align: left;
			width: 100%;
			display: inline-block;
			margin-bottom: 15px;
			font-weight: 800;

			span {
				font-weight: 400;
			}
		}

		.btn {
			margin-top: 20px;
			margin: 20px 5px 0 5px;
		}

		>.error {
			margin-top: 10px;
			color: red;
			font-size: 12px;
			text-align: center;
			display: inline-block;
			margin-bottom: 0;
		}

		.contenedor-input {
			margin-bottom: 0;

			.popup-info {
				right: 12px;
			}
		}

		.contenedor-input label {
			font-weight: 400;
		}

	}

	.dropzone {
		margin-top: 0;
	}

	@media screen and (max-width: 420px) {

		p {
			text-align: center;
		}

		.popup {
			padding: 15px;
		}

		.botones {
			margin-top: 10px;

			.btn {
				padding: 0 15px;
				height: 30px;
				line-height: 30px;
				min-width: 80px;
				font-size: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/ofertas/popup-confirmacion-preinscripcion.vue